<template>
    <section class="about-section">
        <div class="section-header">
            <p class="section-kicker">Guiding Principles</p>
            <h2>Our Values</h2>
            <p>The principles that guide everything we do at Lagos Lawn Tennis Club.</p>
        </div>

        <div class="values-grid">
            <article v-for="(data, index) in ourValuesList" :key="index" class="value-card">
                <div class="icon-wrap">
                    <component :is="data.icon" />
                </div>
                <h3>{{ data.title }}</h3>
                <div class="value-copy" v-html="data.description"></div>
            </article>
        </div>
    </section>
</template>

<script setup>
/* eslint-disable */
import { Award, Heart, Shield, Star, Briefcase, Globe, Users } from "lucide-vue-next";
import { ref, onMounted } from "vue";
import axios from 'axios';

const ourValuesList = ref([]);
const icons = [Award, Heart, Shield, Star, Briefcase, Globe, Users];

onMounted(async () => {
  await listOurValuesRecords();
});

const listOurValuesRecords = async () => {
  try {
    const response = await axios.get('/ourvalues_lists.php');
    if (response.data.status) {
      ourValuesList.value = response.data.data.map((item, index) => ({
        ...item,
        icon: icons[index % icons.length]
      }));
    } else {
      console.error(response.data.message);
    }
  } catch (error) {
    console.error(error.message);
  }
};
</script>

<style scoped lang="scss">
.about-section {
    max-width: 1280px;
    width: 100%;
    margin: 0 auto;
}

.section-header {
    text-align: center;
    margin-bottom: 24px;
}

.section-kicker {
    margin: 0 0 10px;
    color: #0f5b2b;
    font-size: 12px;
    font-weight: 700;
    letter-spacing: 0.16em;
    text-transform: uppercase;
}

.section-header h2 {
    margin: 0;
    font-size: clamp(28px, 3vw, 44px);
    font-weight: 700;
    color: #0f172a;
}

.section-header p {
    margin: 10px auto 0;
    max-width: 760px;
    color: #64748b;
    font-size: 16px;
    line-height: 1.7;
}

.values-grid {
    display: grid;
    grid-template-columns: repeat(3, minmax(0, 1fr));
    gap: 20px;
}

.value-card {
    min-height: 280px;
    padding: 26px;
    border: 1px solid #e3e8ee;
    border-radius: 24px;
    background: linear-gradient(180deg, #ffffff 0%, #f8fbf9 100%);
    box-shadow: 0 12px 28px rgba(15, 23, 42, 0.06);
    text-align: center;
}

.icon-wrap {
    width: 72px;
    height: 72px;
    border-radius: 50%;
    margin: 0 auto 16px;
    border: 1px solid #dce3e7;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #0f5b2b;
    background: #fff;
}

.value-card h3 {
    margin: 0 0 10px;
    font-size: 22px;
    font-weight: 700;
    color: #0f172a;
}

.value-copy {
    color: #64748b;
    font-size: 15px;
    line-height: 1.75;
}

@media (max-width: 992px) {
    .values-grid {
        grid-template-columns: repeat(2, minmax(0, 1fr));
    }
}

@media (max-width: 768px) {
    .values-grid {
        grid-template-columns: 1fr;
    }
}
</style>
